import {useMemo} from 'react';
import {
  ChartOptions,
} from 'chart.js';
import { originalColors } from '../constants/originalColors';
import {MonthlyCostData } from '../constants/types';


export const useMonthlyCostOptions = (chartRef: any, fullDataPoints: number[], env: string): ChartOptions<'bar'> =>
  useMemo(() => ({    
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 900 },
    plugins: {
      legend: { display: false },
      title: {
        display: true,
        text: 'AWS Monthly Cost - '+env,
        font: {
          family: "'Inter', sans-serif",
          size: 16,
          weight: 550,
        },
        padding: {
        bottom: 30,  // <-- Add bottom padding here to create gap
        },
      },
      datalabels: {
        color: '#899093',
        align: 'top',
        anchor: 'end',
        font: {
          family: "'Inter', sans-serif",
          size: 12,
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Month',
          font: { family: "'Inter', sans-serif", size: 14 },
        },
        ticks: { font: { family: "'Inter', sans-serif", size: 14 }, },
        grid: { display: false},
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Monthly Cost ($)',
          font: { family: "'Inter', sans-serif", size: 14 },
        },
        ticks: { font: { family: "'Inter', sans-serif", size: 14, } },
        grid: {color: function (context) {
            return context.index % 2 === 0 ? '#e5e7eb' : 'transparent';
          }}, 
      },
    },
    onHover: (event, elements) => {
      const chart = chartRef.current;
      if (!chart) return;

      const dataset = chart.data.datasets[0];
      const index = elements.length ? elements[0].index : null;

      // Update background colors, dim unhovered bars
      const newBackgroundColors = originalColors.slice(0, fullDataPoints.length).map((color, i) =>
        index === null || i === index ? color : color.replace('1)', '0.3)')
      );

      // Only update if colors actually changed
      if (JSON.stringify(dataset.backgroundColor) !== JSON.stringify(newBackgroundColors)) {
        dataset.backgroundColor = newBackgroundColors;
        chart.update();
      }
    },
  }), [chartRef, fullDataPoints.length]);

export const useExpandedMonthlyCostOptions = (expandedChartRef: any, graphData: MonthlyCostData[], fullLabels: string[], fullDataPoints: number[], hasConfirmed: boolean, env: string): ChartOptions<'bar'> => {
    let filteredDataPoints: number[] = [];

    if (hasConfirmed && graphData) 
    {
      filteredDataPoints = graphData.map(item => item.cost);
    } 
    const baseOptions = useMonthlyCostOptions(expandedChartRef, fullDataPoints, env);

  return {
    ...baseOptions,
    onHover: (event, elements) => {
      const chart = expandedChartRef.current;
      if (!chart) return;

      const dataset = chart.data.datasets?.[0];
      const index = elements.length ? elements[0].index : null;

      if (!dataset) return;

      const newBackgroundColors = originalColors
        .slice(0, filteredDataPoints.length)
        .map((color, i) => index === null || i === index ? color : color.replace('1)', '0.3)'));

      if (JSON.stringify(dataset.backgroundColor) !== JSON.stringify(newBackgroundColors)) {
        dataset.backgroundColor = newBackgroundColors;
        chart.update();
      }
    },
  };
};
